import { Button, Dropdown } from '@cobliteam/ui/components';
import type { ButtonProps } from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { endOfDay, startOfDay } from '@cobliteam/utils/date';
import { useEffect, useState } from 'react';
import TimeWindowOverlay from './components/TimeWindowOverlay';
import useTimeWindow from './hooks/useTimeWindow';
import type { SelectTimeWindowProps } from './types';

type SelectTimeWindowButtonProps = ButtonProps & SelectTimeWindowProps;

const SelectTimeWindow = ({
  internalLabel = 'Mostrar trajeto de:',
  selectedTimeWindow,
  minStartTime = startOfDay(Date.now()).valueOf(),
  maxEndTime = endOfDay(Date.now()).valueOf(),
  onTimeChange,
  showPresets = true,
  ...buttonProps
}: SelectTimeWindowButtonProps) => {
  const [forceClose, setForceClose] = useState(false);

  const {
    timeWindow,
    appliedTimeWindow,
    boundaries,
    timePresets,
    selectedPreset,
    isFilterApplied,
    handleTimeInputChange,
    handleTimeBlur,
    handlePresetSelect,
    handleClearFilter,
    handleSliderChange,
  } = useTimeWindow({
    selectedTimeWindow,
    minStartTime,
    maxEndTime,
    onTimeChange,
  });

  useEffect(() => {
    if (forceClose) setForceClose(false);
  }, [forceClose]);

  return (
    <Dropdown
      forceClose={forceClose}
      overlay={
        <TimeWindowOverlay
          timeWindow={timeWindow}
          boundaries={boundaries}
          timePresets={timePresets}
          selectedPreset={selectedPreset}
          isFilterApplied={isFilterApplied}
          showPresets={showPresets}
          onTimeInputChange={handleTimeInputChange}
          onTimeBlur={handleTimeBlur}
          onSliderChange={handleSliderChange}
          onPresetSelect={handlePresetSelect}
          onClearFilter={handleClearFilter}
        />
      }
    >
      <Button variant='outlined' startIcon={<Icon name='clock' />} {...buttonProps}>
        {appliedTimeWindow && `${appliedTimeWindow.startTime} - ${appliedTimeWindow.endTime}`}
      </Button>
    </Dropdown>
  );
};

export default SelectTimeWindow;
